module.exports = __webpack_public_path__ + "static/media/Artboard – 4.0df4fc46.svg";